module.exports = __webpack_public_path__ + "img/zhanli8.b8cc91fb.jpg";